var render, staticRenderFns
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6785ac24')) {
      api.createRecord('6785ac24', component.options)
    } else {
      api.reload('6785ac24', component.options)
    }
    
  }
}
component.options.__file = "src/views/dms/views/rebate/channel-cost-customer/form/details.vue"
export default component.exports